module.exports = __webpack_public_path__ + "img/hn_thumb_hover.a354a031.png";